import store from '../store'
import _ from 'lodash'

import vm from '../main'
import { httpClient as http } from '../services'

const internals = {}

internals.login = credentials => {
  var userDet
  return http
    .post('/login', credentials)
    .then(response => {
      // http
      //   .get(`user/details?regionId=${response.data.user._id}`)
      //   .then(response1 => {
      //     userDet = response1
      //     console.log("heyyyy", userDet)
      //     response.data.userRegionDetails = userDet.data.docs
      //     store.dispatch('auth/setAuth', response.data)
      //     // store.dispatch('auth/setAuth', response.data)
      //   })
      //   .catch(error => {
      //     console.error('authService.login-error:\n', error)
      //   })
      console.log("rrr",response.data)
        store.dispatch('auth/setAuth', response.data)


    })
    .catch(error => {
      console.error('authService.login-error:\n', error)
      throw error
    })
}

internals.getUserRegionDetails = credentials => {
  return http
    .get(`user/details?regionId=${credentials}`)
    .then(response => {
      console.log('result', response)
      // store.dispatch('auth/setAuth', response.data)
    })
    .catch(error => {
      console.error('authService.login-error:\n', error)
      throw error
    })
}

internals.loginAzure = credentials => {
  return http
    .post('/auth/azure', credentials)
    .then(response => {
      console.log('This is email', response.data.user._id)
      store.dispatch('auth/setAuth', response.data)
    })
    .catch(error => {
      console.error('authService.login-error:\n', error)
      throw error
    })
}

internals.logout = () => {
  store.dispatch('auth/useRefreshToken')
  return http
    .delete('/logout')
    .then(response => {
      store.dispatch('auth/clearAuth')
    })
    .catch(error => {
      console.error('authService.logout-error:\n', error)
      throw error
    })
}

internals.registerUser = user => {
  return http
    .post('/register', { user, registerType: 'Register' })
    .catch(error => {
      console.error('authService.registerUser-error:\n', error)
      throw error
    })
}

internals.inviteUser = user => {
  user = Object.assign({}, user)
  console.log("user",user)
  user.role = user.role.name
  user.rank = user.role.rank
  user.invested_amount = user.invested_amount
  user.password = user.password
   user.startDate = user.startDate

  delete user.isActive
  delete user.isEnabled

  const groups = (user.groups || []).concat([]).map(group => {
    return group.group._id
  })
  const permissions = (user.permissions || []).concat([]).map(permission => {
    return { childId: permission.permission._id, state: permission.state }
  })

  delete user.permissions
  delete user.groups

  const promises = []
  return http
    .post('/register', { user, registerType: 'Invite' })
    .then(result => {
      user = result.data
      if (!_.isEmpty(groups)) {
        promises.push(vm.$userRepository.addManyGroups(user._id, groups))
      }
      if (!_.isEmpty(permissions)) {
        promises.push(
          vm.$userRepository.addManyPermissions(user._id, permissions)
        )
      }

      return Promise.all(promises)
    })
    .catch(error => {
      console.error('authService.inviteUser-error:\n', error)
      throw error
    })
}

internals.sendActivationEmail = email => {
  return http
    .post('/register/send-activation-email', { email })
    .catch(error => {
      console.error('authService.sendActivationEmail-error:\n', error)
      throw error
    })
}

internals.sendResetLink = email => {
  return http.post('/login/forgot', { email }).catch(error => {
    console.error('authService.sendResetLink-error:\n', error)
    throw error
  })
}

internals.resetPassword = (token, password) => {
  console.log('reset', token)
  return http.post('/login/reset', { token, password }).catch(error => {
    console.error('authService.resetPassword-error:\n', error)
    throw error
  })
}

internals.activateAccount = token => {
  return http.post('/register/activate', { token }).catch(error => {
    console.error('authService.activateAccount-error:\n', error)
    throw error
  })
}

export default internals



// WEBPACK FOOTER //
// ./src/services/auth.service.js